import { Flex, Header, Label, useStyles } from '@archipro-design/aria';
import { useHandleTopNavTransitions } from '@archipro-website/top-navigation';
import { useRef } from 'react';

import * as S from './TitleSection.desktop.style';
import { useBoolean } from 'ahooks';

interface TitleSectionProps {
    categoryDescription: string;
    category: string;
    itemsInCategory: number;
    showCategoryTitle?: boolean;
}
const CATEGORY_DESCRIPTION =
    "Find everything you need to build, whether it's a tap or a cladding system. Connect to purchase directly from New Zealand's leading product suppliers.";

export const TitleSectionDesktop = ({
    categoryDescription,
    category,
    itemsInCategory,
    showCategoryTitle = true,
}: TitleSectionProps) => {
    const filterRef = useRef<HTMLDivElement>(null);
    const filterState = useHandleTopNavTransitions(filterRef);
    const [viewAllDescription, descriptionState] = useBoolean(false);
    const { css } = useStyles({
        filterState,
        viewAllDescription,
        showCategoryTitle,
    });

    return (
        <div className={css(S.PageTopSectionWrapper)}>
            <Flex space="between" className={css(S.PageTopSection)}>
                {showCategoryTitle && (
                    <div className={css(S.TitleWrapper)}>
                        <Header inline maximumLines={2}>
                            {category}
                        </Header>
                        <Label inline className={css(S.CategoryCountWrapper)}>
                            {itemsInCategory?.toLocaleString()}
                        </Label>
                    </div>
                )}
                <div className={css(S.CategoryDescriptionWrapper)}>
                    <Label
                        variant="02"
                        maximumLines={viewAllDescription ? 0 : 3}
                        dangerouslySetInnerHTML={{
                            __html:
                                `<p>${categoryDescription}</p>` ||
                                CATEGORY_DESCRIPTION,
                        }}
                        onClick={() => descriptionState.setTrue()}
                    />
                </div>
            </Flex>
        </div>
    );
};
